/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _default = function _default(moment, configOrRange) {
  var range = configOrRange;
  var inclusive = true;
  if (!Array.isArray(configOrRange) && (0, _typeof2.default)(configOrRange) == 'object') {
    range = configOrRange.range;
    if (configOrRange.inclusive !== undefined) {
      inclusive = !!configOrRange.inclusive;
    }
  }
  var start = range[0];
  var end = range.length >= 2 && range[range.length - 1];
  if (!moment) {
    return false;
  }
  if (start && end) {
    var insideRange = start.isBefore(moment) && end.isAfter(moment);
    return inclusive ? insideRange || start.isSame(moment) || end.isSame(moment) : insideRange;
  }
  return false;
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/Calendar/src/utils/isInRange.js
// module id = 237
// module chunks = 0